jQuery(function ($) {
  $(".file-upload-select").each(function (index) {
    let fileInput = $(this).find(".wpcf7-file")[0];
    let selectName = $(this).find(".file-select-name")[0];
    $(this).on("click", function () {
      fileInput.click();
    });
    fileInput.onchange = function () {
      let filename = fileInput.files[0].name;
      selectName.innerText = filename;
    };

   
  });
});
